import React from 'react';
import ReportFrame from '../ReportFrame';

export default class CreditMemosAr extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = { Type: 1 };
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='Credit Memos AR'
          reportParams={reportParams}
          id='creditmemossar'
          name='creditmemosAR'
          title='Credit Memos AR'
          hiddenParameters={['Type']}
        />
      </div>
    );
  }
}
